import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const t = a((c, r) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: r,
    ...c,
    image: (e) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...e,
        children: [
          /* @__PURE__ */ s.jsxs(
            "mask",
            {
              id: "mask0_2974_4177",
              width: 21,
              height: 32,
              x: 14,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: [
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M32.36 15.37H16.65c-1.46 0-2.65 1.18-2.65 2.64v19.34c0 1.46 1.19 2.65 2.65 2.65h15.71c1.46 0 2.64-1.19 2.64-2.64V18.01c0-1.46-1.19-2.64-2.64-2.64m1.14 21.98c0 .63-.51 1.14-1.14 1.14H16.65c-.63 0-1.15-.51-1.15-1.14V18.01c0-.63.51-1.15 1.15-1.15h15.71c.63 0 1.14.51 1.14 1.15zM20.98 13.69c.41 0 .75-.34.75-.75V9.5h5.53v3.44c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.34-.75-.75-.75h-7.03c-.41 0-.75.34-.75.75v4.19c0 .41.34.75.75.75"
                  }
                ),
                /* @__PURE__ */ s.jsx(
                  "path",
                  {
                    fill: "currentColor",
                    d: "M27.39 29.9c-.62.66-1.45 1.02-2.35 1.02-1.78 0-3.22-1.45-3.22-3.24s1.45-3.24 3.22-3.24c.9 0 1.73.36 2.35 1.02.28.3.76.32 1.06.04s.32-.76.03-1.06a4.72 4.72 0 0 0-3.44-1.49c-2.6 0-4.72 2.13-4.72 4.74s2.12 4.74 4.72 4.74c1.3 0 2.55-.54 3.44-1.49.28-.3.27-.78-.03-1.06a.736.736 0 0 0-1.06.02"
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4177)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M-1.145 0h51.052v48H-1.145z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyVitaminCSerumIcon";
export {
  t as AgencyVitaminCSerumIcon,
  t as default
};
//# sourceMappingURL=index.js.map
